/**
 * How many of a list's on-demand filters are narrowing it, for the badge of a
 * `FilterToggle` (the always-on search does not count: it is visible anyway).
 * Call it inside the list's context, e.g. from a header rendered under
 * `<ListBase>`.
 */

import { useListContext } from 'react-admin';

const isSet = (value: unknown) => value !== undefined && value !== null && value !== '';

export const useActiveFilterCount = (alwaysOn: string[] = ['q']): number => {
  const { filterValues } = useListContext();
  return Object.entries(filterValues ?? {}).filter(([key, value]) => !alwaysOn.includes(key) && isSet(value)).length;
};

export default useActiveFilterCount;
